import React from 'react';

const BulletListElement = ({ element }) => {
  const { content } = element;
  const { 
    items = ['List item 1', 'List item 2', 'List item 3'], 
    bulletStyle = 'disc', // 'disc' | 'circle' | 'square'
    alignment = 'left',
    fontSize = 'normal'
  } = content || {};

  const style = {
    textAlign: alignment,
    fontSize: fontSize === 'small' ? '0.875rem' : fontSize === 'large' ? '1.125rem' : '1rem',
    margin: '0.5em 0',
    lineHeight: '1.6',
    paddingLeft: '1.5rem',
    listStyleType: bulletStyle,
    color: 'var(--color-text)'
  };

  return (
    <ul className="builder-bullet-list" style={style}>
      {items.map((item, index) => (
        <li key={index} style={{ marginBottom: '0.25rem' }}>{item}</li>
      ))}
    </ul>
  );
};

export default BulletListElement;
